import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ResponsiveModal from '../../components/ui/ResponsiveModal';

const TechnicalMaintenanceFormModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  wide = false,
}) => (
  <ResponsiveModal
    isOpen={isOpen}
    onClose={onClose}
    className={wide ? 'max-w-5xl' : 'max-w-2xl'}
    closeOnBackdropClick={false}
  >
    <div className="flex max-h-[92dvh] flex-col">
      <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-5 py-4 dark:border-gray-700">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-700 dark:hover:text-gray-200"
          aria-label="Kapat"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">
        {children}
      </div>

      {footer ? (
        <div className="flex shrink-0 justify-end gap-2 border-t border-gray-200 px-5 py-4 dark:border-gray-700">
          {footer}
        </div>
      ) : null}
    </div>
  </ResponsiveModal>
);

export default TechnicalMaintenanceFormModal;
